import { ListItem, ListItemText, ListItemSecondaryAction } from '@mui/material';

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import { parseISO } from 'date-fns';
import { TimeWarningAlarm } from './types';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';
import { formatInTimeZone } from 'date-fns-tz';

interface Props {
  timeWarningAlarm: TimeWarningAlarm;
  index: number;
  handleAlarmDeleted: (index: number) => void;
}

const TimeWarningListItem = ({
  timeWarningAlarm,
  index,
  handleAlarmDeleted,
}: Props) => {
  const { dateFormatWithZeros, timeFormat, timezone } = useUserDateTime();
  const formattedDateTime = formatInTimeZone(
    parseISO(timeWarningAlarm.timestamp),
    timezone,
    `${dateFormatWithZeros} ${timeFormat}`
  );

  return (
    <ListItem button>
      <ListItemText
        primary={`Analyzer Timed Out: ${timeWarningAlarm.analyzerName}`}
        secondary={formattedDateTime}
      />
      <ListItemSecondaryAction>
        <IconButton
          edge='end'
          aria-label='delete'
          onClick={() => handleAlarmDeleted(index)}
          size='large'
        >
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default TimeWarningListItem;
